module.exports = __webpack_public_path__ + "img/1445721627.c6e48738.jpg";